export const LANDING_REDESIGN_2024_FLAG = 'client_pro_landing_page_apo4232_20231214';
